module.exports = __webpack_public_path__ + "static/img/human-4.ab4ebc5a.png";